import DeprecatedAccordion from "./deprecated/Accordion";

/**
 * @deprecated in favor of AccordionV2
 * Desktop version of Accordion has been removed
 * Migration guide:
 * - use AccordionLink or AccordionDropdown as children instead of normal layout elements,
 *   they support same props title, and className as previous dom element children
 *   to supply href and onClick, use AccordionLink element
 *   to supply children, use AccordionDropdown
 * - showExpandAll has been deprecated and removed on AccordionV2 container
 * - instead of expandedGroups used to define initially expanded accordionDropdown elements,
 *   pass isOpen straight into elements instead
 *
 * Once migration is done, default export will be providing Accordion.v2,
 * and AccordionV2 will be deprecated and then removed. To prevent double work renaming components,
 * please use a reexport file in your project for all ui-toolkit components
 */
export default DeprecatedAccordion;
export { Accordion } from "./Accordion";
export { AccordionLink, AccordionLinkReturn } from "./Accordion";
export { AccordionDropdown, AccordionDropdownStateless } from "./Accordion";